import { APP_ROUTES, AUTH_ROUTES, LOWER_CHARS, NUMBER_CHARS, SPECIAL_CHARS } from '../../constants/auth';
import { TRANSLATIONS_AUTH } from '../../translations/auth';

export const isAuthRoute = (path: string) => {
  return AUTH_ROUTES.includes(path);
};

export const isAppRoute = (path: string) => {
  return APP_ROUTES.includes(path);
};

export const getValidationsTexts = () => {
  return {
    description: TRANSLATIONS_AUTH.resetPassword.passwordConditions,
    firstCondition: TRANSLATIONS_AUTH.resetPassword.firtsCondition,
    secondCondition: TRANSLATIONS_AUTH.resetPassword.secondCondition,
    thirdCondition: TRANSLATIONS_AUTH.resetPassword.thirdCondition
  };
};

export const addProviderToEmail = (email: string, provider: string): string => {
  const [username, domain] = email.split('@');
  const modifiedEmail = `${username}+${provider}@${domain}`;
  return modifiedEmail;
};

export const generatePassword = (characterAmount: number) => {
  const lowerChar = getRandomCharacter(LOWER_CHARS);
  const upperChar = getRandomCharacter(LOWER_CHARS).toUpperCase();
  const numberChar = getRandomCharacter(NUMBER_CHARS);
  const specialChar = getRandomCharacter(SPECIAL_CHARS);

  const remainingChars = LOWER_CHARS + LOWER_CHARS.toUpperCase() + NUMBER_CHARS + SPECIAL_CHARS;
  let password = lowerChar + upperChar + numberChar + specialChar;

  for (let i = 0; i < characterAmount - 4; i++) {
    const randomChar = getRandomCharacter(remainingChars);
    password += randomChar;
  }

  password = password
    .split('')
    .sort(() => 0.5 - Math.random())
    .join('');

  return password;
};

const getRandomCharacter = (characters: string) => {
  const array = new Uint32Array(1);
  crypto.getRandomValues(array);
  const randomIndex = array[0] % characters.length;
  return characters[randomIndex];
};

export const removePlusTextFromEmail = (email: string): string => {
  const [username, domain] = email.split('@');
  const cleanedUsername = username.replace(/\+.*/, '');
  const cleanedEmail = `${cleanedUsername}@${domain}`;
  return cleanedEmail;
};
